export default __webpack_public_path__ + "static/media/portfolio2.88c4c973.png";